module.exports = __webpack_public_path__ + "media/images/conference-6-c2c01351f892d321e69c8add8e6ce6d1.jpg";